<template>
  <v-input
    :placeholder="placeholder"
    :name="name"
    :value="value"
    :errors="errors"
    :label="label"
    :classType="classType"
    :extraClass="extraClass"
    @input="onInput"
  >
    <span slot="label">
      {{ label }} <i v-if="cardType" :class="cardIcon" title=""> </i>
    </span>
  </v-input>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import { cardType } from "@/modules/stripe";
import VInput from "@/components/VInput";

export default Vue.component("CreditCardInput", {
  props: {
    name: VueTypes.string.def("creditCardInput"),
    label: VueTypes.string.def("Card Number"),
    placeholder: VueTypes.string.def("4242424242424242"),
    errors: VueTypes.arrayOf(VueTypes.string).def([]),
    value: VueTypes.string,
    classType: VueTypes.string,
    extraClass: VueTypes.string.def("")
  },

  components: {
    VInput
  },

  computed: {
    cardType() {
      return cardType(this.value);
    },

    cardFaName() {
      const type = this.cardType;

      switch (type) {
        case "Visa":
        case "MasterCard":
        case "Discover":
        case "Diners Club":
        case "JCB":
          return type.toLowerCase().replace(/\s/g, "-");

        case "American Express":
          return "amex";

        default:
          return "";
      }
    },

    cardIcon() {
      return `fa fa-cc-${this.cardFaName}`;
    }
  },

  methods: {
    onInput(val) {
      this.$emit("input", val);
    }
  }
});
</script>

<style scoped>
i {
  margin-left: 5px;
}
</style>
